import useSendBoardEvent, {
  BoardTransitionEvent,
  MachineGroup,
} from "./state-machine/sendBoardEvent";
import { useCallback } from "react";
import { Board } from "../../../../reducers/uploadedBoard";
import { useBoardFromContext } from "./board";

export function useRunPlacementChecks() {
  const boardStuff = useBoardFromContext();
  const board = boardStuff.board as Board;
  const { sendBoardEvent, loading } = useSendBoardEvent(undefined);

  const checkPlacement = useCallback(() => {
    void sendBoardEvent(board.id, {
      machine_group: MachineGroup.BOARD,
      model_id: board.id,
      event: BoardTransitionEvent.SHOULD_CHECK_PLACEMENTS,
    });
  }, [board.id, sendBoardEvent]);

  return { checkPlacement, startingPlacementCheck: loading };
}

export function useRunSelectionChecks() {
  const boardStuff = useBoardFromContext();
  const board = boardStuff.board as Board;
  const { sendBoardEvent, loading } = useSendBoardEvent(undefined);

  const checkSelections = useCallback(() => {
    void sendBoardEvent(board.id, {
      machine_group: MachineGroup.BOARD,
      model_id: board.id,
      event: BoardTransitionEvent.SHOULD_CHECK_SELECTIONS,
    });
  }, [board.id, sendBoardEvent]);

  return { checkSelections, startingSelectionsCheck: loading };
}
